import { EnvelopeSimple } from "@phosphor-icons/react";

const ContactNote = ({ className = "" }) => (
  <div
    className={"text-center py-6 text-sm text-white/55 " + className}
    data-testid="contact-note"
  >
    <p className="leading-relaxed">
      <span className="font-medium text-white/75">¿Tienes dudas o sugerencias?</span>{" "}
      Te leo!{" "}
      <a
        href="mailto:soymaulozano@gmail.com"
        className="inline-flex items-center gap-1 mono font-mono text-aqua hover:text-aqua/80 transition-colors hover:underline underline-offset-4"
        data-testid="contact-note-email"
      >
        <EnvelopeSimple size={13} weight="bold" />
        soymaulozano@gmail.com
      </a>
    </p>
  </div>
);

export default ContactNote;
